import { render, staticRenderFns } from "./paper-required-fields-update-for-citation-popup.html?vue&type=template&id=1b8a3afc&scoped=true&external"
import script from "./paper-required-fields-update-for-citation-popup.js?vue&type=script&lang=js&external"
export * from "./paper-required-fields-update-for-citation-popup.js?vue&type=script&lang=js&external"
import style0 from "./paper-required-fields-update-for-citation-popup.scss?vue&type=style&index=0&id=1b8a3afc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a3afc",
  null
  
)

export default component.exports